<dpac-modal
  title="Hai bisogno di maggiori informazioni?"
  description="Compila il form per metterti in contatto con la Mappa del Patrimonio"
  size="custom"
  [canClose]="true"
  (closed)="onClose()"
>
  <form modal-body [formGroup]="form" class="mt-5 w-full contact-form">
    <div class="gap-4 grid grid-cols-1 md:grid-cols-2">
      <div class="relative mb-2">
        <dpac-input-field
          formControlName="entity"
          label="Denominazione/Ente di riferimento"
          placeholder="Inserisci"
          [required]="true"
        />
      </div>

      <div class="relative mb-2">
        <dpac-input-field
          formControlName="email"
          type="email"
          label="Email"
          placeholder="nome@dominio.it"
          [required]="true"

        />
      </div>

      <div class="relative mb-2">
        <dpac-input-field
          formControlName="name"
          label="Nome"
          placeholder="Mario"
          [required]="true"
        />
      </div>

      <div class="relative mb-2">
        <dpac-input-field
          formControlName="surname"
          label="Cognome"
          placeholder="Rossi"
          [required]="true"
        />
      </div>

      <div class="relative md:col-span-2 mb-2">
        <dpac-select
          formControlName="requestReason"
          label="Motivo della richiesta"
          placeholder="Seleziona"
          [options]="reasonOptions"
          optionLabel="descrizione"
          optionValue="id"
          [required]="true"
        />
      </div>

      <div class="relative col-span-full mb-2">
        <dpac-textarea
          formControlName="message"
          label="Messaggio (Max 300 caratteri)"
          placeholder="Inserisci il messaggio"
          [maxLength]="300"
          [required]="true"
          [showCharCount]="true"
        />
      </div>

      <p class="col-span-full text-[#666] text-sm">*Campi obbligatori</p>

      <div class="col-span-full bg-gray-50 mt-4 p-4 rounded-sm privacy-container">
        <dpac-checkbox
          formControlName="privacy"
          [error]="!!(form.get('privacy')?.invalid && form.get('privacy')?.touched)"
        >
          Dichiaro di aver letto e compreso l'
          <a
            routerLink="/privacy-policy"
            class="contact-privacy-link"
            (click)="$event.stopPropagation(); onClose()"
          >informativa sulla privacy</a>
          e acconsento al trattamento dei miei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR).*
        </dpac-checkbox>
      </div>
    </div>
  </form>

  <div modal-buttons class="flex gap-4 contact-actions">
    <dpac-button
      classe="tertiary"
      label="Annulla"
      (onClick)="onClose()"
    />
    <dpac-button
      classe="primary"
      label="Invia messaggio"
      [disabled]="form.invalid || submitting()"
      (onClick)="onSubmit()"
    />
  </div>
</dpac-modal>
